import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";

export function WelcomeDescription() {
  const isCompactView = useIsCompactView();

  return (
    <div className={`${isCompactView && "px-4"} flex flex-col gap-4 z-20`}>
      <p
        className="text-[34px] sm:text-[62px] font-bold text-center leading-tight 
        drop-shadow-[0_3px_3px_rgba(0,0,0,0.4)] text-white"
      >
        Text to Mobile App
      </p>
      <p
        className={`text-[16px] sm:text-[20px] text-white text-center drop-shadow-[0_3px_3px_rgba(0,0,0,0.4)]`}
      >
        Build fully functional, high-performance native{" "}
        {isCompactView && <br />}
        mobile apps in minutes — just from text.
        <br />
        Powered by AI. Crafted with Flutter.
      </p>
    </div>
  );
}
